import CreateOrderModule from './CreateOrder.module';

export * from './CreateOrderModuleProps';
export default CreateOrderModule;
